import { render, staticRenderFns } from "./former-years-list.vue?vue&type=template&id=b72655b6&scoped=true"
import script from "./former-years-list.vue?vue&type=script&lang=js"
export * from "./former-years-list.vue?vue&type=script&lang=js"
import style0 from "./former-years-list.vue?vue&type=style&index=0&id=b72655b6&prod&scpoed=true&lang=css"
import style1 from "../../statistics/css/companyOchart.css?vue&type=style&index=1&id=b72655b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72655b6",
  null
  
)

export default component.exports